// Centralized plan configuration

// Utility function to format numbers with commas
const formatNumberWithCommas = number => {
  return number.toLocaleString();
};

export const PLAN_NAMES = {
  FREE: 'Free',
  PRO: 'Professional',
  ENTERPRISE: 'Enterprise',
};

export const PLANS = {
  [PLAN_NAMES.FREE]: {
    name: PLAN_NAMES.FREE,
    price: '$0',
    period: 'forever',
    description: 'Perfect for getting started',
    actions: '100',
    aiCredits: '50',
    users: '1',
    storage: '500MB',
    // workflows: '5',
    // components: '50',
    // taskDuration: '1 month',
    support: 'Community support',
    integrations: 'Basic integrations only',
    features: [
      '100 actions',
      '50 AI credits',
      '1 users',
      '500MB file storage',
      '5 workflows',
      '50 components per workflow',
      '2,000 character AI message limit',
    ],
    popular: false,
  },
  [PLAN_NAMES.PRO]: {
    name: PLAN_NAMES.PRO,
    basePrice: 20,
    period: 'per month',
    description: 'Most popular choice for growing teams',
    actions: '3,000',
    aiCredits: '300',
    users: '10',
    storage: '1GB',
    workflows: 'Unlimited',
    components: '250',
    taskDuration: '6 months',
    support: 'Email and Slack support',
    integrations: 'Advanced integrations',
    baseFeatures: [
      '10 users',
      '1GB file storage',
      'Unlimited workflows',
      '250 components per workflow',
      '10,000 character AI message limit',
      'Email and Slack support',
      'Trigger and Action integrations',
    ],
    popular: false,
  },
  [PLAN_NAMES.ENTERPRISE]: {
    name: PLAN_NAMES.ENTERPRISE,
    price: 'Custom',
    period: 'pricing',
    description: 'For large organizations with advanced needs',
    actions: 'Unlimited',
    aiCredits: 'Unlimited',
    users: 'Unlimited',
    storage: 'Unlimited',
    // workflows: 'Unlimited',
    // components: 'Unlimited',
    // taskDuration: 'Custom',
    support: 'Priority support',
    integrations: 'Custom integrations',
    features: [
      'Custom actions',
      'Custom AI credits',
      'Custom users',
      'Custom file storage',
      // 'Unlimited workflows',
      // 'Unlimited components',
      // 'Custom task duration',
      'Priority support and implementation assistance',
      'Custom integrations',
      'Dedicated account manager',
    ],
    popular: false,
  },
};

export const ADD_ONS = {
  ACTIONS: {
    id: 'actions',
    name: 'Extra Actions',
    basePrice: 10,
    period: 'per 1,000 actions',
    description: 'Add workflow actions',
    unit: 1000,
    features: [
      '1,000 additional actions',
      'Same execution speed',
      'No expiration',
      'Stackable purchases',
    ],
  },
  AI_CREDITS: {
    id: 'aiCredits',
    name: 'Extra AI Credits',
    basePrice: 10,
    period: 'per 100 credits',
    description: 'Add AI credits to your plan',
    unit: 100,
    features: [
      '100 additional AI credits',
      'All AI features included',
      'No expiration',
      'Stackable purchases',
    ],
  },
};

// Helper functions
export const getPlan = planName => PLANS[planName];

export const getAllPlans = () => Object.values(PLANS);

export const getAddOn = addOnId => Object.values(ADD_ONS).find(addon => addon.id === addOnId);

export const getAllAddOns = () => Object.values(ADD_ONS);

export const calculateProPlanPrice = (basePrice, addOnQuantities) => {
  const addOnCosts = {
    actions: addOnQuantities.actions * ADD_ONS.ACTIONS.basePrice,
    aiCredits: addOnQuantities.aiCredits * ADD_ONS.AI_CREDITS.basePrice,
  };
  return basePrice + addOnCosts.actions + addOnCosts.aiCredits;
};

export const calculateProPlanFeatures = addOnQuantities => {
  const baseActions = 3000;
  const baseAiCredits = 300;

  const totalActions = baseActions + addOnQuantities.actions * ADD_ONS.ACTIONS.unit;
  const totalAiCredits = baseAiCredits + addOnQuantities.aiCredits * ADD_ONS.AI_CREDITS.unit;

  return [
    {
      text: `${formatNumberWithCommas(totalActions)} actions per month`,
      animated: true,
      animationType: null, // This will be set by the component
    },
    {
      text: `${formatNumberWithCommas(totalAiCredits)} AI credits`,
      animated: true,
      animationType: null, // This will be set by the component
    },
    ...PLANS[PLAN_NAMES.PRO].baseFeatures,
  ];
};
